class ProductCardCarousel {
  constructor() {
    this.carousels = new Map();
    this.init();
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  init() {
    const carousels = document.querySelectorAll('.product-card__carousel');
    
    if (carousels) {
      carousels.forEach(carousel => {
        this.initCarousel(carousel);
      });

      this.addClickListeners();

      if(window.innerWidth >= 1000) {
        this.addHoverListeners();
      }

      this.handleResize = this.debounce(() => {
        // console.log("debounde");
        
        if(window.innerWidth >= 1000) {
          this.addHoverListeners();
        }
      }, 250);

      window.addEventListener('resize', this.handleResize);
    }
  }

  initCarousel(carousel) {
    const container = carousel.closest('.product-card__figure');
    if (!container) return;
    const carouselId = this.generateId();
    const carouselData = {
      element: carousel,
      container: carousel.querySelector('.product-card__carousel-wrapper'),
      slides: carousel.querySelectorAll('.product-card__carousel-slide'),
      breadcrumbDots: container.querySelectorAll('.product-card__breadcrumb'),
      isHovering: false,
      userInteracted: false
    };
    this.carousels.set(carouselId, carouselData);
    carousel.dataset.carouselId = carouselId;
    this.addScrollHandler(carouselData);
  }

  addHoverListeners() {
    document.addEventListener('mouseover', (e) => {
      if (e.target.closest('.product-card__figure')) {
        const figure = e.target.closest('.product-card__figure');
        if (!figure) return;
        if (e.target.closest('.product-card__breadcrumbs')) return;
        const carousel = figure.querySelector('.product-card__carousel');
        const carouselData = this.carousels.get(carousel?.dataset.carouselId);
        if (carouselData && !carouselData.userInteracted) {
          carouselData.isHovering = true;
          this.showSlide(carouselData, 1);
        }
      }
    });

    document.addEventListener('mouseout', (e) => {
      if (e.target.closest('.product-card__figure')) {
        const figure = e.target.closest('.product-card__figure');
        if (!figure) return;
        const relatedTarget = e.relatedTarget;
        if (relatedTarget && relatedTarget.closest('.product-card__figure') === figure) {
          return;
        }
        const carousel = figure.querySelector('.product-card__carousel');
        const carouselData = this.carousels.get(carousel?.dataset.carouselId);
        if (carouselData && !carouselData.userInteracted) {
          carouselData.isHovering = false;
          this.showSlide(carouselData, 0);
        }
      }
    });
  }

  addClickListeners() {
    document.addEventListener('click', (e) => {
      if (e.target.closest('.product-card__breadcrumb')) {
        const breadcrumb = e.target.closest('.product-card__breadcrumb');
        if (!breadcrumb) return;
        const container = breadcrumb.closest('.product-card__figure');
        const carousel = container?.querySelector('.product-card__carousel');
        const carouselData = this.carousels.get(carousel?.dataset.carouselId);
        if (carouselData) {
          carouselData.userInteracted = true;
          this.handleBreadcrumbClick(e, carouselData, breadcrumb);
        }
      }
    });
  }

  showSlide(carouselData, slideIndex) {
    const { container, slides } = carouselData;
    if (!container || !slides.length || slideIndex >= slides.length) return;
    const slide = slides[slideIndex];
    const scrollPosition = slide.offsetLeft - (container.offsetWidth - slide.offsetWidth) / 2;
    container.scrollTo({ left: scrollPosition, behavior: 'smooth' });
    this.updateActiveStates(carouselData, slideIndex);
  }

  handleBreadcrumbClick(e, carouselData, breadcrumb) {
    e.preventDefault();
    e.stopPropagation();
    const slideIndex = parseInt(breadcrumb.dataset.breadcrumb);
    this.showSlide(carouselData, slideIndex);
  }

  generateId() {
    return 'carousel_' + Math.random().toString(36).substr(2, 9);
  }

  addScrollHandler(carouselData) {
    const { container } = carouselData;
    if (!container) return;
    let scrollTimeout;
    container.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => this.updateActiveSlide(carouselData), 0);
    }, { passive: true });
  }

  updateActiveSlide(carouselData) {
    const { container, slides,  } = carouselData;
    if (!container || !slides.length) return;
    const containerCenter = container.getBoundingClientRect().left + container.offsetWidth / 2;
    let activeIndex = 0;
    let minDistance = Infinity;
    slides.forEach((slide, index) => {
      const slideCenter = slide.getBoundingClientRect().left + slide.offsetWidth / 2;
      const distance = Math.abs(slideCenter - containerCenter);
      if (distance < minDistance) {
        minDistance = distance;
        activeIndex = index;
      }
    });
    this.updateActiveStates(carouselData, activeIndex);
  }

  updateActiveStates(carouselData, activeIndex) {
    const { slides, breadcrumbDots } = carouselData;
    slides?.forEach((slide, index) => {
      slide.classList.toggle('product-card__carousel-slide--active', index === activeIndex);
    });
    breadcrumbDots?.forEach((dot, index) => {
      dot.classList.toggle('product-card__breadcrumb--active', index === activeIndex);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ProductCardCarousel();
});

document.addEventListener('facet:updated', () => {
  new ProductCardCarousel();
});